import React, { Component, Fragment } from "react";
import _ from "lodash";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import auth from "../../services/authService";
import { trackPromise } from "react-promise-tracker";
//Importar Componentes
import NavBar from "./navBar";
import LoadingComp from "../tools/loadingComp";
import InfoTable from "../views/infoTable";
import InfoGrid from "../views/infoGrid";
import InfoOptions from "../views/infoOptions";
import PagoUpdate from "../forms/pagoUpdate";
//Importar Servicios
import { getEvents, exportEventos } from "../../services/eventosService";

class Pagos extends Component {
  state = {
    data: [],
    dataSumm: [],
    arrYr: [],
    arrWeek: [],
    weekNo: 1,
    yr: 2022,
    view: "table",
    user: {},
    filters: {
      registros: 20,
      busqueda: "",
    },
    infoModal: false,
    selectedEvent: {
      idEventos: 0,
      Unidad: 0,
      Emp1: 0,
      Emp2: 0,
      Comentarios: "",
      Inicio_G: "",
      Fin_G: "",
    },
    layout: [
      {
        name: "idEventos",
        label: "",
      },
      {
        name: "fecha",
        label: "",
      },
      { name: "Nombre", label: "Cliente: " },
      { name: "Nombre_Evento", label: "Evento: " },
      { name: "Hora_Inicio", label: "Inicio: " },
      { name: "Hora_Final", label: "Fin: " },
    ],
    headers: [
      {
        name: "idEventos",
        head: "Id",
        sort: "desc",
      },
      {
        name: "Nombre",
        head: "Cliente",
        sort: "desc",
      },
      {
        name: "Nombre_Evento",
        head: "Evento",
        sort: "desc",
      },
      {
        name: "Lugar",
        head: "Lugar",
        sort: "desc",
      },
      {
        name: "fecha",
        head: "Fecha",
        sort: "desc",
      },
      {
        name: "HourDiff",
        head: "Horas",
        sort: "desc",
      },
      {
        name: "Costo",
        head: "Costo p/Hora",
        sort: "desc",
      },
      {
        name: "Costo_Extra",
        head: "Costo Extra",
        sort: "desc",
      },
      {
        name: "Status_Pago",
        head: "Estatus",
        sort: "desc",
        content: (evento) => (
          <span
            className={
              evento.Status_Pago === "PTE PAGO"
                ? "label-pendiente"
                : evento.Status_Pago === "CANCELADO"
                ? "label-cancelado"
                : "label-activo"
            }
          >
            {evento.Status_Pago}
          </span>
        ),
      },
      {
        name: "validadoger",
        head: "Validado",
        sort: "desc",
        content: (evento) => (
          <span
            className={
              evento.validadoger === 1 ? "label-activo" : "label-cancelado"
            }
          >
            {evento.validadoger === 1 ? "COMPLETO" : "INCOMPLETO"}
          </span>
        ),
      },
    ],
  };

  componentDidMount = async () => {
    try {
      const { status, data } = await trackPromise(getEvents());
      const user = auth.getCurrentUser();
      if (status === 200) {
        let yr = parseInt(new Date().getFullYear());
        yr -= 6;
        const arrYr = [...Array(10).keys()].map((x) => x + yr);
        const arrWeek = [...Array(54).keys()].map((x) => x + 1);
        /************* Get Week Number *****************/
        let d = new Date();
        d.setDate(d.getDate() - 4);
        // Copy date so don't modify original
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        // Get first day of year
        let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        // Calculate full weeks to nearest Thursday
        let weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7) + 2;
        // Return array of year and week number
        /************* Get Week Number *****************/
        const dataFilter = data.filter(
          (e) => e.semana === weekNo && e.yr === arrYr[1]
        );
        const dataSumm = dataFilter.slice(0, this.state.filters.registros);
        this.setState({
          data,
          dataSumm,
          user,
          arrYr,
          arrWeek,
          weekNo,
          yr: arrYr[1],
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Ocurrió un error cargando los datos",
          showConfirmButton: false,
          timer: 1800,
          toast: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Verifica tu conexión a internet e intenta de nuevo",
        showConfirmButton: false,
        timer: 1800,
        toast: true,
      });
    }
  };

  changeDate = ({ currentTarget: input }) => {
    let { yr, weekNo, data } = this.state;
    yr = input.name === "yrFilter" ? parseInt(input.value) : yr;
    weekNo = input.name === "weekFilter" ? parseInt(input.value) : weekNo;
    const dataFilter = data.filter((e) => e.semana === weekNo && e.yr === yr);
    const dataSumm = dataFilter.slice(0, this.state.filters.registros);
    this.setState({ yr, weekNo, dataSumm });
  };

  sortColumn = (name, sort, key) => {
    const { data, headers, filters, weekNo, yr } = this.state;
    const registros = data.slice(0, filters.registros);
    const dataFilter = registros.filter(
      (e) => e.semana === weekNo && e.yr === yr
    );
    const order = sort === "desc" ? "asc" : "desc";
    const dataOrder = _.orderBy(dataFilter, name, order);
    const updateHeader = [...headers];
    updateHeader[key].sort = order;
    this.setState({ dataSumm: dataOrder, headers: updateHeader });
  };

  changeFilter = ({ currentTarget: input }) => {
    const { data, weekNo, yr } = this.state;
    const filters = { ...this.state.filters };
    filters[input.name] = input.value;
    const dataSumm = filters.busqueda
      ? data.filter(
          (w) =>
            w.semana === weekNo &&
            w.yr === yr &&
            (w.Nombre.toLowerCase().includes(filters.busqueda.toLowerCase()) ||
              w.idEventos.toString().startsWith(filters.busqueda) ||
              w.Nombre_Evento.toString().startsWith(filters.busqueda))
        )
      : data
      ? data
          .slice(0, filters.registros)
          .filter((w) => w.semana === weekNo && w.yr === yr)
      : [];

    this.setState({ dataSumm, filters });
  };

  showModal = () => {
    const infoModal = !this.state.infoModal;
    this.setState({ infoModal });
  };

  loadInfo = (data) => {
    this.showModal();
    const selectedEvent = (({
      idEventos,
      Costo,
      Costo_Extra,
      HourDiff,
      Status_Pago,
      tblpagos,
      Validado,
      validadoger,
      Status_Factura,
      Num_Factura,
      Comentarios,
    }) => ({
      idEventos,
      Costo,
      Costo_Extra,
      HourDiff,
      Status_Pago,
      tblpagos,
      Validado,
      validadoger,
      Status_Factura,
      Num_Factura,
      Comentarios,
    }))(data);
    this.setState({ selectedEvent });
  };

  updateInfo = (info) => {
    const { data, filters, weekNo, yr } = this.state;
    const id = info.id;
    const i = _.findIndex(data, { idEventos: id });
    data[i].Status_Pago = info["Status_Pago"];
    data[i].Status_Factura = info["Status_Factura"];
    data[i].Num_Factura = info["Num_Factura"];
    data[i].Comentarios = info["Comentarios"];
    data[i].Validado = info["Validado"];
    data[i].validadoger = info["validadoger"];
    data[i].tblpagos = info["tblpagos"];
    const dataFilter = data.filter((e) => e.semana === weekNo && e.yr === yr);
    const dataSumm = dataFilter.slice(0, filters.registros);

    this.setState({ data, dataSumm });
    this.showModal();
  };

  handleExport = async () => {
    try {
      if (this.state.user.tipo !== "Paramedico") {
        const { status, data } = await trackPromise(exportEventos());
        if (status === 200) {
          let wb = XLSX.utils.book_new();
          let ws = XLSX.utils.json_to_sheet(data);
          XLSX.utils.book_append_sheet(wb, ws, "Pagos");
          XLSX.writeFile(wb, "Pagos.csv");
        }
      }
    } catch (err) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Ocurrió un error cargando los datos",
        showConfirmButton: false,
        timer: 1800,
        toast: true,
      });
    }
  };

  render() {
    const {
      headers,
      dataSumm,
      view,
      layout,
      filters,
      arrWeek,
      arrYr,
      weekNo,
      yr,
      infoModal,
      selectedEvent,
      user,
    } = this.state;

    return (
      <Fragment>
        {infoModal ? (
          <PagoUpdate
            data={selectedEvent}
            onUpdate={this.updateInfo}
            closeModal={this.showModal}
            user={user}
          />
        ) : null}
        <LoadingComp />
        <NavBar page={this.props.match.path} />
        <div className="p-5 h-screen">
          <h1 className="block text-center text-3xl text-purple-700">
            Módulo de Pagos
          </h1>
          <InfoOptions
            view={view}
            filters={filters}
            pholder={"Evento"}
            btnText={"Evento"}
            arrYr={arrYr}
            arrWeek={arrWeek}
            weekNo={weekNo}
            yr={yr}
            btnColor={"btn-secondary"}
            changeFilter={this.changeFilter}
            handleExport={this.handleExport}
            changeDate={this.changeDate}
          />
          <InfoTable
            headColor={"bg-purple-100"}
            evento={true}
            headers={headers}
            dataSumm={dataSumm}
            loadInfo={this.loadInfo}
            sortColumn={this.sortColumn}
            view={view}
          />
          <InfoGrid
            dataSumm={dataSumm}
            loadInfo={this.loadInfo}
            layout={layout}
            view={view}
          />
        </div>
      </Fragment>
    );
  }
}

export default Pagos;
